<template>
  <div class="setting-pathEffect">
    <!-- 路径样式 -->
    <div class="radios">
      <div class="radios__title">
        路径样式
      </div>
      <!-- click事件加stop是为了冒泡到window -->
      <div class="path-type">
        <div v-for="(item, key) in pathTypeList" :key="key">
          <div :class="{active: item.active, 'path-type-select': true}" @click.stop="selectPathType($event, item, key)">
            <i :class="{[item.name]: true}"></i>
          </div>
          <span class="path-name">{{item.text}}</span>
        </div>
      </div>
    </div>
    <!-- 单次运动速度 -->
    <div class="onceTime">
      <div class="onceTime__title">
        {{'单次运动时间 ' + time.now/1000 + 's'}}
      </div>
      <div class="slider">
        <div class="slider-before">0.5s</div>
        <div class="rc-slider">
          <div class="rc-slider-rail"></div>
          <div class="rc-slider-track" :style="{'width': (time.now-time.min)/(time.max-time.min)*100 + '%'}"></div>
          <div v-dragHandle class="rc-slider-handle" :style="{'left': (time.now-time.min)/(time.max-time.min)*100 + '%'}"></div>
        </div>
        <div class="slider-after">{{time.max | timeDeal}}</div>
      </div>
    </div>
    <!-- 单次运动速度 -->
    <div class="radios">
      <div class="radios__title">
        单次运动速度
      </div>
      <ul class="radios__list">
        <li class="radios__item" 
        :class="{active: item.active}" 
        v-for="(item, key) in easingList" 
        :key="key"
        @click="selectSpeed(item, key)">
          <i></i>
          <span>{{item.text}}</span>
        </li>
      </ul>
    </div>
    <!-- 循环运动 -->
    <div class="loop">
      <div>循环运动</div>
      <div>
        <el-switch v-model="isLoop" @change="setloop"></el-switch>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:['sprite'],
  data () {
    return {
      ANALYSIS: {
        Path : {category:'route_animation_setting', action:'click_line', label:'路径动画_设置路径_直线'},
        FreePath : {category:'route_animation_setting', action:'click_free_style', label:'路径动画_设置路径_自由'},
        Bessel : {category:'route_animation_setting', action:'click_curve_path', label:'路径动画_点击_曲线路径'},
        Ellipse : {category:'route_animation_setting', action:'click_circle', label:'路径动画_设置路径_圆圈'},
        timer : {category:'route_animation_setting', action:'click_timer_shaft', label:'路径动画_设置路径_调整时长'},
        rotation : {category:'route_animation_setting', action:'click_rotation', label:'路径动画_设置路径_勾选循环'},
        cRotation : {category:'route_animation_setting', action:'click_cancel_rotation', label:'路径动画_设置路径_取消勾选循环'}
      },
      popupType: 'pathEffectSetting',                         // 控制弹窗
      pathType: 'Path',                                       // 路径动画类型
      pathTypeList: [
        {type: 'Path', text: '直线', name: 'icon-path-line', active: true},
        {type: 'Bessel', text: '曲线', name: 'icon-path-bessel', active: false},
        {type: 'Ellipse', text: '圆圈', name: 'icon-path-ellipse', active: false},
        {type: 'FreePath', text: '自由', name: 'icon-path-freePath', active: false}
      ],
      easing: 'easeInOutQuad',                                 // 动画速度
      easingList: [
        {type: 'linear', text: '匀速', active: false},
        {type: 'easeInOutQuad', text: '加速', active: true},
        {type: 'easeOutQuint', text: '减速', active: false}
      ],
      dragHandle: false,                                        // 是否在拖拽
      time: {                                                   // 单次运动时间
        min: 500,
        now: 500,
        max:1000
      },
      isLoop: false,                                             // 是否循环
      isShow: false
    }
  },
  mounted () {
    this.$bus.on('effectSetting.pathAnim', (data) => {
      if(data.state === 'out') return
      this.initPathAnim()
      this.initData()
    })
    this.$bus.on('undoRedoHandle', this._undoRedoHandle);
    this.$bus.on('changePath_pathSetting', this._pathSetting);
  },
  methods: {
    initData() {
      // 初始化数据
      this.isShow = false;
      if (!this.sprite) return;
      this.isShow = true;
      if(this.sprite.effect.pathAnim) {
        this.pathType = this.sprite.effect.pathAnim.type || 'Path';
        this.easing = this.sprite.effect.pathAnim.easing || 'easeInOutQuad';
        this.isLoop = this.sprite.effect.pathAnim.loop;
      } else {
        this.pathType = 'Path';
        this.easing = 'easeInOutQuad';
        this.isLoop = false;
      }

      this.getTimeInfo();

      this.pathTypeList.forEach((val, k) => {
        val.active = false;
        this.pathType === val.type && (val.active = true);
      })
      this.easingList.forEach((val, k) => {
        val.active = false;
        this.easing === val.type && (val.active = true);
      })
    },
    getTimeInfo() {
      // 获取时间
      let effect = this.sprite.effect;

      this.time.max = effect.exitAnim.start - effect.entranceAnim.end;
      this.time.now = effect.pathAnim.end ? effect.pathAnim.end - effect.entranceAnim.end : 500;
    },
    selectPathType(e, item, key) {
      // 类型选择
      if(item.active) return;
      let pathAnim = {}, action = 'init';
      this.pathTypeList.forEach((val, k) => {
        val.active = false;
        k === key && (val.active = true);
      })

      pathAnim.type = item.type;
      pathAnim.easing = this.easing;

      // 撤销数据
      let undoData = {
        spriteId: this.sprite.id,
        scenesId: this.sprite.scenesId,
        reData: this.sprite.effect.getPathAnim(),
        scale: this.sprite.editor.scale
      };

      // 初始化路径位置(边缘问题没有完成)
      if(item.type === 'Path') {
        pathAnim.info = {
          width: 100,
          height: 100,
          rotate: 0,
        };
        pathAnim.target = {
          w: this.sprite.width,
          h: this.sprite.height,
          x: this.sprite.positionLeft + 100,
          y: this.sprite.positionTop + 100,
          rotate: this.sprite.rotate
        };
      } else if(item.type === 'Ellipse') {
        pathAnim.info = {
          width: 200,
          height: 200,
          rotate: 0,
        };
        pathAnim.target = {
          w: this.sprite.width,
          h: this.sprite.height,
          x: this.sprite.positionLeft,
          y: this.sprite.positionTop,
          rotate: this.sprite.rotate
        };
      } else if(item.type === 'FreePath') {
        action = 'paint';
        pathAnim = {
          point: [e.pageX, e.pageY]
        };
        this.sprite.update({})
        // 关闭本弹窗
        this.$bus.emit('FeaturesPop_close_vue', {type: 3});
      } else if(item.type === 'Bessel') {
        pathAnim.info = {
          width: 100,
          height: 100,
          path: [0, 0, 70, 0, 30, 100, 100, 100],
          rotate: 0,
        };
        pathAnim.target = {
          w: this.sprite.width,
          h: this.sprite.height,
          x: this.sprite.positionLeft + 100,
          y: this.sprite.positionTop + 100,
          rotate: this.sprite.rotate
        };
      }

      undoData.action = action;
      undoData.data = pathAnim;

      // 重新设置后事件
      this.$bus.emit('set_path_anim', {action: action, pathAnim: pathAnim});

      eve("undo_redo", null, {type: 'path_pathType', data: undoData})
      this.$analysis(this.ANALYSIS[item.type]);
    },
    selectSpeed(item, key) {
      // 速度选择
      if(item.active) return;
      let undoData = {};
      undoData.spriteId = this.sprite.id;
      undoData.scenesId = this.sprite.scenesId;
      undoData.reData = this.easing;
      this.easingList.forEach((val, k) => {
        val.active = false;
        k === key && (val.active = true);
      })
      this.easing = item.type;
      undoData.data = item.type;
      this.sprite.updateEffect({
        pathAnim: {
          easing: item.type
        }
      });

      eve("undo_redo", null, {type: 'path_changeSpeed', data: undoData})
    },
    setloop() {
      this.sprite.updateEffect({
        pathAnim: {
          loop: this.isLoop
        }
      });

      this.$bus.emit('changePath_pathSetting', {
        name: 'pathEffectSetting',
        end: this.sprite.effect.entranceAnim.end + this.time.now,
        loop: this.isLoop
      });

      eve("undo_redo", null, {
        type: 'path_setLoop', 
        data: {
          spriteId: this.sprite.id,
          scenesId: this.sprite.scenesId,
        }
      })
      this.$analysis(this.isLoop ? this.ANALYSIS.cRotation : this.ANALYSIS.rotation);
    },
    dragMouseup(now) {
      // 拖拽设置时间
      let ent= this.sprite.effect.entranceAnim;
      let undoData = {
        spriteId: this.sprite.id,
        scenesId: this.sprite.scenesId,
        reData: {
          start: ent.end,
          end: ent.end + now
        },
        data: {
          start: ent.end,
          end: ent.end + this.time.now
        }
      }
      this.sprite.updateEffect({
        pathAnim: undoData.data
      });
      this.$bus.emit('changePath_pathSetting', {
        name: 'pathEffectSetting',
        end: ent.end + this.time.now,
        loop: this.isLoop
      });
      eve("undo_redo", null, {type: 'path_changeTime', data: undoData})
      this.$analysis(this.ANALYSIS.timer);
    },
    initPathAnim() {
      if(!this.sprite) return;
      if(!this.sprite.effect.pathAnim.target) {
        let code = this.sprite.effect.code
        if(this.isSpecialEffect(code)) {
          code = 'FadeIn'
        }
        let { positionTop: y, positionLeft: x, width: w, height: h, rotate } = this.sprite;
        let start = this.sprite.effect.entranceAnim.end,
            end = start + 2000;
        end > this.sprite.effect.exitAnim.start && (end = this.sprite.effect.exitAnim.start);
        end <= start && (end = start + 500);
        this.sprite.updateEffect({
          code: code,
          entranceAnim:{
            start: this.sprite.effect.entranceAnim.start,
            end: this.sprite.effect.entranceAnim.end
          },
          pathAnim: {
            start: start,
            end: end,
            scale: this.sprite.editor.scale,
            target: {
              x: x + 100,
              y: y + 100,
              rotate,
              w: w,
              h: h
            }
          },
          stayAnim: {
            type: 'None'
          }
        }, true)
        this.$bus.emit('updateEffect_vue', {
          sprite: this.sprite,
          effect: this.sprite.effect || {},
          type: 'path'
        });
      }
    },
    _pathSetting(data) {
      if(this.isShow && data.name === 'selection') {
        this.initData()
      }
    },
    _undoRedoHandle(data) {
      // 撤销或恢复后事件
      (data.type ==='updateSpriteEffect' || data.type === 'path_pathType' || data.type === 'path_changeSpeed' || data.type === 'path_setLoop' || data.type === 'path_changeTime') && this.initData();
    },
    isDrawEffect (code) {
      return /^(?:draw|hand|write)$/i.test('' + code);
    },
    isAppearEffect (code) {
      return /^(?:appear|type|bounce|roll)$/i.test('' + code);
    },
    isSpecialEffect (code) {
      return this.isDrawEffect(code) || this.isAppearEffect(code);
    }
  },
  directives: {
    dragHandle(el, binding, vnode) {
      let _this = vnode.context,
          now = 0,
          mousemove = null,
          mouseup = null,
          disx = 0;

      mousemove = (e) => {
        // 拖动改变时间
        let pre = (disx - e.pageX) / 146 * (_this.time.max - _this.time.min);
        pre = Math.round(pre / 1000 * 2) / 2 * 1000;
        _this.time.now = (now - pre) < _this.time.min ? _this.time.min : (now - pre) > _this.time.max ? _this.time.max : now - pre;
        _this.time.now = + _this.time.now.toFixed(1)
      }
      mouseup = (e) => {
        document.removeEventListener('mousemove',mousemove);
        document.removeEventListener('mouseup',mouseup);
        _this.dragHandle = false;
        _this.dragMouseup(now);
        now = 0;
      }

      el.onmousedown = (e) =>{
        e.preventDefault();
        e.stopPropagation();

        _this.dragHandle = true;
        now = _this.time.now;
        disx = e.pageX;

        document.addEventListener('mousemove', mousemove);
        document.addEventListener('mouseup', mouseup);
      }
    },
  },
  filters: {
    timeDeal(time) {
      if(!time) return "0.5s"
      let calc = Math.round(time/1000*2) / 2;
      calc = calc * 10 % 10 ? calc + 's' : calc + '.0s';
      return calc;
    }
  },
  beforeDestroy () {
    this.$bus.off('effectSetting.pathAnim')
    this.$bus.off('undoRedoHandle', this._undoRedoHandle)
    this.$bus.off('changePath_pathSetting', this._pathSetting)
  }
}
</script>

<style lang="scss" scoped>
.setting-pathEffect {
    padding: 14px 0;
    margin-top: 7px;
}

.radios {
  padding-left: 18px;
  padding-right: 18px;
  margin-bottom: 20px;

  &__title {
    margin-bottom: 13px;
    font-size: 14px;
    text-align-last: left;
  }

  &__list {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  &__item {
    display: flex;
    align-items: center;
    font-size: 14px;
    cursor: pointer;

    &>i {
      width: 16px;
      height: 16px;
      border-radius: 16px;
      border: solid 1px #474260;
    }
    &>span {
      padding-left: 5px;
    }

    &.active>i {
      background-color: #474260;
      box-shadow: 0 0 0 3px #ffffff inset;
    }
  }
}

.onceTime {
  padding-left: 18px;
  padding-right: 18px;
  margin-bottom: 20px;

  &__title {
    margin-bottom: 13px;
    font-size: 14px;
    text-align-last: left;
  }
}

.slider {
  width: 100%;
  display: flex;
  
  .slider-before {
    width: 26px;
    margin-right: 10px;
  }
  .slider-after {
    width: 26px;
    margin-left: 10px;
  }
}

.rc-slider {
  position: relative;
  height: 15px;
  padding: 5px 0;
  width: 146px;
  -ms-touch-action: none;
  touch-action: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  * {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }

  .rc-slider-rail {
    position: absolute;
    width: 100%;
    background-color: #e6e6f4;
    height: 4px;
    border-radius: 3px;
  }

  .rc-slider-track {
    position: absolute;
    background-color: #474260;
    border-radius: 3px;
    height: 4px;
    left: 0%;
    width: 69.1515%;
  }

  .rc-slider-handle {
    position: absolute;
    margin-left: -8px;
    margin-top: -6px;
    left: 69.1515%;
    width: 16px;
    height: 16px;
    background-color: #474260;
    border: 0;
    cursor: -webkit-grab;
    cursor: grab;
    border-radius: 50%;
    -ms-touch-action: pan-x;
    touch-action: pan-x;
  }
}

.loop {
  display: flex;
  padding-left: 18px;
  padding-right: 18px;
  margin-bottom: 20px;
  line-height: 18px;
  > div {
    margin-right: 10px;
  }
}
.path-type{
  display: flex;
  justify-content: space-between;
  align-items: center;

  .path-type-select {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto 5px;
    width: 32px;
    height: 32px;
    background-color: #f0f0f8;
    border-radius: 4px;
    border: 1px solid transparent;
    cursor: pointer;

    &:hover, &.active{
      border-color: #627DF2;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/popups/pathEffectSetting.vue